<template>
  <v-container fluid>
    <template v-if="details">
      <v-row wrap>
        <v-col cols="6" class="py-1">
          <DisplayField label="Year" :value="details.year" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Make" :value="details.make" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Model" :value="details.model" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="VIN" :value="details.vin" />
        </v-col>
      </v-row>

      <template v-if="viewingMore">
        <v-divider />

        <v-row class="py-2" wrap>
          <v-col cols="6" class="py-1">
            <DisplayField label="Cov Type" :value="vehicleCoverageType" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Body Type" :value="autoBodyStyle" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Territory" :value="details.territory" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Use" :value="autoUseType" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="SYM " :value="details.auto.symbol" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Driver Class" :value="details.auto.driverClass" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Cost New" :value="details.costNew" type="currency" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Comp SYM" :value="details.auto.compSymbol" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Coll SYM" :value="details.auto.collSymbol" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Zip Code" :value="details.zipCode" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Hot Car Discount" :value="details.auto.hasHotCarDiscount" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="License State" :value="details.auto.licenseState" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="License Plate" :value="details.auto.licensePlate" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Fleet Id" :value="details.auto.fleetId" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Comp. Vehicle #" :value="details.companyVehicleNumber" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Assigned Driver" :value="details.auto.assignedDriver" />
          </v-col>
        </v-row>
        <v-divider />
          <v-row v-if="details.isPersonal" class="py-2" wrap>
            <v-col cols="6" class="py-1">
              <DisplayField label="Annual Miles" :value="details.auto.annualMiles" type="number" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Commute Miles" :value="details.auto.commuteMiles" type="number" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="4x4" :value="details.auto.is4x4" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Odometer" :value="details.auto.odometerMiles" type="number" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Odometer Date" :value="details.auto.odometerDate" type="date" />
            </v-col>
          </v-row>
          <v-divider />
          <v-row v-if="details.isCommercial" class="py-2" wrap>
            <v-col cols="6" class="py-1">
              <DisplayField label="Factor" :value="details.auto.factor" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Farthest Terminal" :value="details.auto.farthestTerminal" type="number" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Gross Vehicle Weight" :value="details.auto.grossVehicleWeight" type="number" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Radius" :value="details.auto.radius" type="number" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Seat Capacity" :value="details.auto.seatCapacity" type="number" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="SIC" :value="details.auto.sic" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Vehicle Type" :value="vehicleType" />
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="py-2" wrap>
            <v-col cols="12" class="section-header pt-0 pb-1">Safety Devices</v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Passive Seat Belts" :value="details.auto.hasPassiveSeatBelts" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Anti-Lock Brakes" :value="details.auto.hasAntiLockBrakes" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Air Bag" :value="airBagType" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Anti-Theft" :value="autoAntiTheftType" />
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="py-2" wrap>
            <v-col cols="12" class="section-header pt-0 pb-1">Discounts</v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Passive Restraint" :value="details.auto.hasPassiveRestraintDiscount" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Anti-Lock Brakes" :value="details.auto.hasAntiLockDiscount" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Anti-Theft" :value="details.auto.hasAntiTheftDiscount" type="bool" />
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="py-2" wrap>
            <v-col cols="12" class="section-header pt-0 pb-1">Questionnaire</v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Registered To Insured?" :value="details.auto.isRegisteredToInsured" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Is Modified or Salvaged?" :value="details.auto.isSalvaged" type="bool" />
            </v-col>
             <v-col cols="6" class="py-1">
              <DisplayField label="Special Equipment?" :value="details.auto.hasSpecialEquipment" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Has Damage?" :value="details.auto.hasDamage" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Kept At School?" :value="details.auto.isAtSchool" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Parked On Street?" :value="details.auto.isParkedOnStreet" type="bool" />
            </v-col>
            <v-col cols="6" class="py-1">
              <DisplayField label="Agent Inspected?" :value="details.auto.isInspected" type="bool" />
            </v-col>
          </v-row>
      </template>

      <v-row justify="end">
        <v-col cols="6" class="text-end">
          <a class="link" @click="toggleView">
            {{ viewMoreText }}
          </a>
        </v-col>
      </v-row>
      <v-row v-if="hasSummaryCoverages">
        <v-col cols="12" class="py-0 title">Coverage Summary</v-col>
        <v-col cols="12" class="pt-0 pb-1 value">Total Premium: ${{ details.totalPremium }}</v-col>
        <v-col v-if="shouldDisplayBI" cols="6" class="py-1">
          <DisplayField label="Bodily Injury" :value="bodilyInjuryLimit" />
        </v-col>
        <v-col v-if="shouldDisplayCsl" cols="6" class="py-1">
          <DisplayField label="Combined Single Limit" :value="cslLimit" />
        </v-col>
        <v-col v-if="shouldDisplayPD" cols="6" class="py-1">
          <DisplayField label="Property Damage" :value="propDamageLimit" />
        </v-col>
        <v-col v-if="shouldDisplayComp" cols="6" class="py-1">
          <DisplayField label="Comprehensive" :value="compDed" />
        </v-col>
        <v-col v-if="shouldDisplayCol" cols="6" class="py-1">
          <DisplayField label="Collision" :value="colDed" />
        </v-col>
        <v-col class="caption py-1">View the <a @click="switchToCoveragesTab">coverages tab</a> to see all coverages</v-col>
      </v-row>
      <v-row>
        <v-col class="px-0 py-0">
          <AdditionalInterests :data="details.additionalInterests" />
        </v-col>
      </v-row>

    </template>
    <template v-else-if="!loading">
      <v-row>
        <v-col>
          Unable to get information. Please try again later.
        </v-col>
      </v-row>
    </template>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading vehicle details...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.section-header {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #767676;
  }
</style>

<script>
import enumService from '@/services/shared/enumService.js';
import analyticsService from '@/services/shared/analyticsService.js';
import { mapState, mapActions } from 'vuex';

import DisplayField from '@/components/Shared/DisplayField.vue';
import AdditionalInterests from '@/components/Shared/AdditionalInterests.vue';

export default {
  name: 'VehicleDetails',
  components: {
    AdditionalInterests,
    DisplayField
  },
  props: {
    details: {
      type: Object,
      default: null
    },
    loading: Boolean
  },
  data: function () {
    return {
      viewingMore: false,
      interestSelected: false,
      selectedInterest: null,
      biCode: 'BI',
      pdCode: 'PD',
      compCode: 'COMP',
      collCode: 'COLL',
      cslCode: 'CSL'
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode', 'autoVehicleTabGtagConfig']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    vehicleId: function () {
      return this.$route.params.vehicleId;
    },
    viewMoreText: function () {
      return this.viewingMore ? 'View Less' : 'View More';
    },
    vehicleCoverageType: function () {
      return enumService.vehicleCoverageTypes[this.details.auto.vehicleCoverageType];
    },
    autoUseType: function () {
      return enumService.autoUseTypes[this.details.auto.autoUseType];
    },
    autoBodyStyle: function () {
      return enumService.autoBodyStyles[this.details.auto.autoBodyStyle];
    },
    airBagType: function () {
      return enumService.airBagTypes[this.details.auto.airBagType];
    },
    autoAntiTheftType: function () {
      return enumService.autoAntiTheftTypes[this.details.auto.autoAntiTheftType];
    },
    vehicleType: function () {
      return enumService.commercialVehicleTypes[this.details.auto.vehicleType];
    },
    hasSummaryCoverages: function () {
      return ((this.details.summaryCoverages || null) !== null) && this.details.summaryCoverages.length > 0;
    },
    shouldDisplayBI: function () {
      return this.details.summaryCoverages.findIndex(x => x.code === this.biCode) !== -1;
    },
    bodilyInjuryLimit: function () {
      var biCovIdx = this.details.summaryCoverages.findIndex(x => x.code === this.biCode);
      if (biCovIdx !== -1) {
        return `Limit: ${this.details.summaryCoverages[biCovIdx].limits}`;
      }
      return '';
    },
    shouldDisplayPD: function () {
      return this.details.summaryCoverages.findIndex(x => x.code === this.pdCode) !== -1;
    },
    propDamageLimit: function () {
      var pdCovIdx = this.details.summaryCoverages.findIndex(x => x.code === this.pdCode);
      if (pdCovIdx !== -1) {
        return `Limit: ${this.details.summaryCoverages[pdCovIdx].limits}`;
      }
      return '';
    },
    shouldDisplayComp: function () {
      return this.details.summaryCoverages.findIndex(x => x.code === this.compCode) !== -1;
    },
    compDed: function () {
      var compCovIdx = this.details.summaryCoverages.findIndex(x => x.code === this.compCode);
      if (compCovIdx !== -1) {
        return `Ded: ${this.details.summaryCoverages[compCovIdx].deductibles}`;
      }
      return '';
    },
    shouldDisplayCol: function () {
      return this.details.summaryCoverages.findIndex(x => x.code === this.collCode) !== -1;
    },
    colDed: function () {
      var colCovIdx = this.details.summaryCoverages.findIndex(x => x.code === this.collCode);
      if (colCovIdx !== -1) {
        return `Ded: ${this.details.summaryCoverages[colCovIdx].deductibles}`;
      }
      return '';
    },
    shouldDisplayCsl: function () {
      return this.details.summaryCoverages.findIndex(x => x.code === this.cslCode) !== -1;
    },
    cslLimit: function () {
      var cslCovIdx = this.details.summaryCoverages.findIndex(x => x.code === this.cslCode);
      if (cslCovIdx !== -1) {
        return `Limit: ${this.details.summaryCoverages[cslCovIdx].limits}`;
      }
      return '';
    }
  },
  methods: {
    ...mapActions(['setError', 'setActiveVehicleTab']),
    toggleView: function () {
      if (!this.viewingMore) {
        analyticsService.sendEvent(this.$gtag, 'View More', 'Policy', 'Auto Vehicle View More');
      }
      this.viewingMore = !this.viewingMore;
    },
    switchToCoveragesTab: function () {
      analyticsService.sendEvent(this.$gtag, this.autoVehicleTabGtagConfig.action, this.autoVehicleTabGtagConfig.category, this.autoVehicleTabGtagConfig.label);
      this.setActiveVehicleTab(1);
    }
  }
};
</script>
